var React = require('react');

function PlayFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M1.066 23.662a2.26 2.26 0 0 0 2.196.1l19.49-9.746A2.24 2.24 0 0 0 24 12c0-.86-.478-1.63-1.248-2.016L3.258.237a2.25 2.25 0 0 0-2.192.102A2.24 2.24 0 0 0 0 2.255v19.491a2.24 2.24 0 0 0 1.066 1.916","clipRule":"evenodd"}));
}

PlayFilled.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = PlayFilled;

PlayFilled.default = PlayFilled;
